module.exports = __webpack_public_path__ + "img/pysnaike.62b3105b.png";